exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sbd-avatar[data-v-06cb086e]{width:64px;height:64px;line-height:64px;display:inline-block;text-align:center;background:#ccc;color:#fff;white-space:nowrap;position:relative;overflow:hidden;vertical-align:middle;border-radius:50%}.sbd-avatar.ivu-avatar-circle[data-v-06cb086e]{border-radius:50%}.sbd-avatar.ivu-avatar-square[data-v-06cb086e]{border-radius:8px}.sbd-height-auto[data-v-06cb086e]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06cb086e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/model/avatar/avatar.vue
// module id = 15
// module chunks = 0